import moment from 'moment';

export function resolveDateRangeFromConfig(config, viewKey = null) {
  const preset = config?.default_date_range || 'current_month';
  const today = moment();

  switch (preset) {
    case 'today':
      return [today.clone().startOf('day'), today.clone().endOf('day')];
    case 'current_month':
      return [today.clone().startOf('month'), today.clone()];
    case 'last_two_months':
      return [today.clone().subtract(2, 'months').startOf('month'), today.clone()];
    case 'last_three_months':
      return [today.clone().subtract(3, 'months').startOf('month'), today.clone()];
    case 'custom':
      if (config?.custom_from_date && config?.custom_upto_date) {
        return [
          moment(config.custom_from_date, 'DD-MM-YYYY'),
          moment(config.custom_upto_date, 'DD-MM-YYYY'),
        ];
      }
      return [today.clone().startOf('month'), today.clone()];
    default:
      return [today.clone().startOf('month'), today.clone()];
  }
}

export function formatResolvedRange(config, viewKey) {
  const [fromDate, toDate] = resolveDateRangeFromConfig(config, viewKey);
  const preset = config?.default_date_range || 'current_month';

  if (viewKey === 'work_schedule' && preset !== 'custom' && preset !== 'today') {
    return `${fromDate.format('DD-MM-YYYY')} onward (includes upcoming jobs)`;
  }

  if (preset === 'today') {
    return fromDate.format('DD-MM-YYYY');
  }

  return `${fromDate.format('DD-MM-YYYY')} → ${toDate.format('DD-MM-YYYY')}`;
}

export function buildWorkScheduleQueryParams(config) {
  const preset = config?.default_date_range || 'current_month';
  const [fromDate, toDate] = resolveDateRangeFromConfig(config, 'work_schedule');
  const params = {
    from_date: fromDate.format('DD-MM-YYYY'),
  };

  if (preset === 'today' || preset === 'custom') {
    params.upto_date = toDate.format('DD-MM-YYYY');
  } else {
    params.include_upcoming = '1';
  }

  if (config?.schedule_statuses?.length) {
    params.schedule_statuses = config.schedule_statuses.join(',');
  }
  if (config?.record_statuses?.length) {
    params.record_statuses = config.record_statuses.join(',');
  }
  if (config?.plant_ids?.length) {
    params.plant_ids = config.plant_ids.join(',');
  }
  return params;
}

export function buildDeliveryChallanQueryParams(config) {
  const [fromDate, toDate] = resolveDateRangeFromConfig(config, 'delivery_challan');
  const params = {
    from_date: fromDate.format('DD-MM-YYYY'),
    upto_date: toDate.format('DD-MM-YYYY'),
  };
  if (config?.plant_ids?.length) {
    params.plant_ids = config.plant_ids.join(',');
  }
  return params;
}

export function buildDesignMixQueryParams(config) {
  const [fromDate, toDate] = resolveDateRangeFromConfig(config, 'design_mix');
  const params = {
    from_date: fromDate.format('DD-MM-YYYY'),
    upto_date: toDate.format('DD-MM-YYYY'),
  };
  if (config?.plant_ids?.length) {
    params.plant_ids = config.plant_ids.join(',');
  }
  return params;
}

function buildStandardListQueryParams(config, viewKey, includePlants = false) {
  const [fromDate, toDate] = resolveDateRangeFromConfig(config, viewKey);
  const params = {
    from_date: fromDate.format('DD-MM-YYYY'),
    upto_date: toDate.format('DD-MM-YYYY'),
  };
  if (includePlants && config?.plant_ids?.length) {
    params.plant_ids = config.plant_ids.join(',');
  }
  return params;
}

export function buildGoodsReceiptNoteQueryParams(config) {
  return buildStandardListQueryParams(config, 'goods_receipt_note', true);
}

export function buildQuotationQueryParams(config) {
  return buildStandardListQueryParams(config, 'quotation', false);
}

export function buildPurchaseOrderQueryParams(config) {
  return buildStandardListQueryParams(config, 'purchase_order', false);
}

export function buildSalesOrderQueryParams(config) {
  return buildStandardListQueryParams(config, 'sales_order', false);
}

export function buildEquipmentQueryParams(config) {
  return buildStandardListQueryParams(config, 'equipment', false);
}

export function buildCheckInQueryParams(config) {
  return buildStandardListQueryParams(config, 'check_in', true);
}

export function appendQueryParams(url, params) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  const queryString = query.toString();
  return queryString ? `${url}?${queryString}` : url;
}
